var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDownXs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.29289 6.12126C4.68342 5.73074 5.31658 5.73074 5.70711 6.12126L7.82843 8.24258L9.94975 6.12126C10.3403 5.73074 10.9734 5.73074 11.364 6.12126C11.7545 6.51179 11.7545 7.14495 11.364 7.53548L8.53553 10.3639C8.14501 10.7544 7.51184 10.7544 7.12132 10.3639L4.29289 7.53548C3.90237 7.14495 3.90237 6.51179 4.29289 6.12126Z",
  fill: "currentColor"
})));
export { SvgChevronDownXs as ReactComponent };